
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { copyToClipboard } from '@/utils/general';
import Toast from '@/utils/toast';
import InfoBanner from '@/components/shared/suites/InfoBanner.vue';
import TextButton from '@/components/shared/suites/TextButton.vue';
import TextField from '@/components/shared/TextField.vue';

@Component<IntegrationSettings>({
	components: {
		InfoBanner,
		TextButton,
		TextField
	}
})
export default class IntegrationSettings extends Vue {
	@Action('fetchCalendarSubscriptionUrl', { namespace: 'dashboard' }) private fetchCalendarSubscriptionUrl!: () => { url: string; webcalUrl: string };

	private subscriptionUrl: string = '';
	private webcalUrl: string = '';
	private loading: boolean = false;
	private showNonAppleDeviceWarning: boolean = false;

	private get isNonApplePlatform(): boolean {
		return /Windows|Linux|CrOS|Android/i.test(navigator.userAgent);
	}

	private async created(): Promise<void> {
		this.loading = true;
		try {
			const { url, webcalUrl } = await this.fetchCalendarSubscriptionUrl();
			this.webcalUrl = webcalUrl;
			this.subscriptionUrl = url;
		}
		catch (errorMessage) {
			Toast.error(this.$t('settings.integrations.error_fetching_url', { errorMessage }));
		}
		finally {
			this.loading = false;
		}
	}

	private onAppleCalendarClick(): void {
		if (this.isNonApplePlatform) {
			this.showNonAppleDeviceWarning = true;
		}
		else {
			window.open(this.webcalUrl, '_blank');
		}
	}

	private async copyUrlToClipboard(): Promise<void> {
		await copyToClipboard(this.subscriptionUrl, () => Toast.success(this.$t('settings.integrations.copy_success')));
	}
}

